<template>
    <div style="color: #ffffff" class="flex">
        <div style="flex-direction: column" class="center">
            <div class="panoramaIcon"></div>
            <div>720全景</div>
        </div>
        <div style="flex-direction: column" class="center">
            <div class="BIMIcon"></div>
            <div>BIM</div>
        </div>
        <div style="flex-direction: column" class="center">
            <div class="renderingIcon"></div>
            <div>效果图</div>
        </div>
        <div style="flex-direction: column" class="center">
            <div class="videoIcon"></div>
            <div>视频</div>
        </div>
    </div>
</template>

<script>
import { getDateAndTimeStr } from '../../../../untils/misc.js';

export default {
    name: 'iconsGroup',

    props: {
        headerIntegration: {
            title: String,
            secondTitle: String,
        },
    },

    components: {},

    data() {
        return {
            showMenu: false,
        }
    },

    mounted() {},

    computed: {},

    methods: {
        getDateAndTimeStr() {
            return getDateAndTimeStr(new Date());
        }
    }
}
</script>

<style lang="less" scoped>
.panoramaIcon {
    width: 5.73vw;
    height: 9.1vh;
    background: url('../../../../assets/image/homeTemp/720Icon.png');
    background-size: 100% 100%;
}

.panoramaIcon:hover {
    width: 6.87vw;
    height: 10.92vh;
    background: url('../../../../assets/image/homeTemp/720Icon-hover.png');
    background-size: 100% 100%;
}

.BIMIcon {
    .panoramaIcon();
    background: url('../../../../assets/image/homeTemp/BIMIcon.png');
    background-size: 100% 100%;
}

.BIMIcon:hover {
    width: 6.87vw;
    height: 10.92vh;
    background: url('../../../../assets/image/homeTemp/BIMIcon-hover.png');
    background-size: 100% 100%;
}

.renderingIcon {
    .panoramaIcon();
    background: url('../../../../assets/image/homeTemp/rendering.png');
    background-size: 100% 100%;
}

.renderingIcon:hover {
    width: 6.87vw;
    height: 10.92vh;
    background: url('../../../../assets/image/homeTemp/rendering-hover.png');
    background-size: 100% 100%;
}

.videoIcon {
    .panoramaIcon();
    background: url('../../../../assets/image/homeTemp/video.png');
    background-size: 100% 100%;
}

.videoIcon:hover {
    width: 6.87vw;
    height: 10.92vh;
    background: url('../../../../assets/image/homeTemp/video-hover.png');
    background-size: 100% 100%;
}
</style>
